import { bankStateSchema, type BankState } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const fetchBankState = (signal: AbortSignal): Promise<unknown> =>
  apiRequest<unknown>('/bank', { signal });

export const getBankState = async (signal: AbortSignal): Promise<BankState> =>
  bankStateSchema.parse(await fetchBankState(signal));
